// export const toAbsoluteUrl = (pathname: string) => 'https://bfaf.ae' + pathname
export const toAbsoluteUrl = (pathname: string) => 'https://atras.bfaf.ae' + pathname
// export const toAbsoluteUrl = (pathname: string) => 'http://127.0.0.1:8000' + pathname

